'use client';

import type {
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';
import { fetchCategories } from '@eliadmin/core/src/api/products/product-api';
import { HeaderCartButton } from '@eliadmin/core/src/components/header/header-cart-button';
import { HeaderFavoritesButton } from '@eliadmin/core/src/components/header/header-favorites-button';
import { HeaderProfileButton } from '@eliadmin/core/src/components/header/header-profile-button';
import { MobileSearchProvider } from '@eliadmin/core/src/components/header/mobile-search';
import MobileSidebar from '@eliadmin/core/src/components/header/mobile-sidebar';
import { HeaderSearchBar } from '@eliadmin/core/src/components/header/search-bar';
import { SearchButton } from '@eliadmin/core/src/components/header/search-button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Logo } from '@eliadmin/core/src/components/ui/logo';

export type HeaderMainProps = {
  generalLayout: GeneralLayout['data'];
  categories: Awaited<ReturnType<typeof fetchCategories>>['data'];
  menu: Menu;
};

export function HeaderMain({ generalLayout, categories, menu }: HeaderMainProps) {
  return (
    <MobileSearchProvider>
      <div className={cn('custom-section', 'py-3 sm:pb-2 sm:pt-4')}>
        <div className={cn('custom-container', 'flex items-center justify-between gap-6')}>
          <div className="flex w-full flex-1 items-center justify-start sm:hidden">
            <MobileSidebar categories={categories} menu={menu?.fields ?? []} side="left" />
          </div>
          <Logo
            className={{ image: 'h-10 sm:h-12 lg:h-14 xl:h-16' }}
            generalLayout={generalLayout}
          />
          <div className="hidden w-full max-w-[450px] lg:block">
            <HeaderSearchBar />
          </div>
          <div className="flex w-full flex-1 items-center justify-end gap-2 sm:w-fit sm:flex-grow-0 xl:gap-3">
            <div className="flex items-center justify-center lg:hidden">
              <SearchButton />
            </div>
            <div className="hidden items-center justify-end gap-2 sm:flex xl:gap-3">
              <HeaderFavoritesButton />
              <HeaderProfileButton />
              <HeaderCartButton />
            </div>
          </div>
        </div>
      </div>
    </MobileSearchProvider>
  );
}
